import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIcons } from '../../../hooks/useIcons';
import { intakeSourceName, listIntakeSources } from './intakeSources';
import './IntakeBar.scss';

/**
 * The intake strip across the top of the dashboard. Every crate starts from one
 * of these, so they read as tabs rather than cards competing with the console.
 */
export const IntakeBar: React.FC = () => {
  const { icons } = useIcons();
  const history = useHistory();
  const sources = listIntakeSources();

  return (
    <nav className="intake-bar" aria-label="Import from">
      <div className="intake-bar-tabs">
        {sources.map((source) => (
          <button
            key={source.id}
            type="button"
            className={`intake-tab brand-${source.brand}`}
            title={source.description}
            onClick={() => history.push(source.to)}
          >
            <img
              className="intake-tab-icon"
              src={icons[source.iconKey] || ''}
              alt=""
              style={{
                visibility: icons[source.iconKey] ? 'visible' : 'hidden',
              }}
            />
            <span className="intake-tab-label">
              {source.emphasis ? (
                <>
                  <strong>{source.emphasis}</strong> {source.label}
                </>
              ) : (
                intakeSourceName(source)
              )}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default IntakeBar;
